import React from "react";
import style from "./style";
import FakerProduts from "@/components/Fakes/products";
import FakerCommercialArea from "@/components/Fakes/commercial-area";

const FakeTvDetail = () => {
  return (
    <div className="container faker-tv-detail">
      <div className="tv">
        <div className="tv-packages">
          <div className="skeleton title" />
          <div className="skeleton tvPackage" />
          <div className="skeleton tvPackage" />
          <div className="skeleton tvPackage" />
        </div>
        <div className="skeleton title" />
        <div className="tv-buttons">
          <div className="skeleton tvButton" />
          <div className="skeleton tvButton" />
          <div className="skeleton tvButton" />
        </div>
        <div className="skeleton title" />
        <div className="tv-platforms">
          <div className="skeleton tvPlatform" />
          <div className="skeleton tvPlatform" />
          <div className="skeleton tvPlatform" />
        </div>
      </div>

      <div className="banners">
        <FakerCommercialArea />
      </div>

      <style jsx>{style}</style>
    </div>
  );
};

export default FakeTvDetail;
